export const SUPPORT_EMAIL = 'support@choco-up.com';
export const SALES_EMAIL = 'hello@choco-up.com';
export const DD_EMAIL = 'dd@choco-up.com'; // DD = Due Diligence
